/**
 * Created by Josef Jurca on 19/01/2018.
 */

/**
 * Converts reminder data from read data.
 *
 * @param {Object} [data] - Read data.
 * @returns {Object} Reminder data.
 */
export function convertFromRead (data = {}) {

    let {result} = data;

    return {
        id:  result.id || '',
        name: result.name || '',
        assetId: result.assetId || '',
        type: result.type || '',
        objectType: result.objectType || ''
    };
}

/**
 * Converts asset data from read data.
 *
 * @param {Object} [data] - Read data.
 * @returns {Object} Reminder data.
 */
export function convertFromListReminderRead (data = {}) {

    let {result} = data,
        {objects} = result;

    if (!objects.length) {
        return null;
    }

    return {
        id:  objects[0].id || '',
        name: objects[0].name || '',
        assetId: objects[0].assetId || '',
        type: objects[0].type || '',
        objectType: objects[0].objectType || ''
    };
}

/**
 * Converts application data for set reminder request.
 *
 * @param {number} assetId - Asset id.
 * @returns {Object} Request data.
 */
export function convertForSetReminder (assetId) {

    return {
        reminder: {
            'type': 'ASSET',
            'assetId': assetId,
            'objectType':'KalturaAssetReminder'
        }
    };
}

/**
 * Converts application data for remove reminder request.
 *
 * @param {number} reminderId - Reminder id.
 * @returns {Object} Request data.
 */
export function convertForRemoveReminder (reminderId) {

    return {
        id: reminderId,
        type: '0'
    };
}

/**
 * Converts application data for get reminder request.
 *
 * @param {number} assetId - Asset id.
 * @returns {Object} Request data.
 */
export function convertForGetReminder (assetId) {

    return {
        filter: {
            kSql: '(or epg_id:' + assetId + ')',
            objectType: 'KalturaAssetReminderFilter'
        }
    };
}


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/adapters/reminder.js